import type { FeatureGroup } from '../../../types';
import { PAYMENTS_FEATURE_GROUP } from '../group';

export const PAYMENTS_TAKE_PAYMENT_FEATURE_GROUP: FeatureGroup = {
  guid: 'b1f0c3a4-5d62-4e78-9a01-3c7d5e9f03ff',
  name: 'payments_take_payment',
  description: 'Taking a payment on a patron behalf from the payments page',
  product: 'payments',
  parentGuid: PAYMENTS_FEATURE_GROUP.guid,
};
